import { render, staticRenderFns } from "./ProductsCreate.vue?vue&type=template&id=837e57ba&"
import script from "./ProductsCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports